import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PubnubService } from 'src/app/shared/pubnub/pubnub.service';

@Injectable({ providedIn: 'root' })
export class PubnubListenerService {
  constructor(private readonly _pubnub: PubnubService) {}
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this._pubnub.subscribe(['entity-deletes', 'global'], {
      timeoutStrategy: 'silentlyContinue',
    });
  }
}
